import { CaseType, LawType, Maybe } from "../../../generated";

export interface LawTypeState {
  currentLawType: Maybe<LawType>,
  currentCaseType: Maybe<CaseType>
}

export const lawTypeInitialState: LawTypeState = {
  currentLawType: null,
  currentCaseType: null
};

export enum LawTypeActionType {
  SET_CURRENT_LAW_TYPE = "setCurrentCourtLawType",
  SET_CURRENT_CASE_TYPE = "setCurrentCourtCaseType",
}

export type LawTypeAction =
  | { type: LawTypeActionType.SET_CURRENT_LAW_TYPE, currentLawType: Maybe<LawType> }
  | { type: LawTypeActionType.SET_CURRENT_CASE_TYPE, currentCaseType: Maybe<CaseType> }


export const lawTypeReducer = (state: LawTypeState, action: LawTypeAction): LawTypeState => {
  switch (action.type) {
    case LawTypeActionType.SET_CURRENT_LAW_TYPE:
      return {
        ...state,
        currentLawType: action.currentLawType
      }

    case LawTypeActionType.SET_CURRENT_CASE_TYPE:
      return {
        ...state,
        currentCaseType: action.currentCaseType
      }
    default:
      return state;
  }
};
